<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Dies academicus" />
            <DiesAcademicus />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import DiesAcademicus from './DiesAcademicus.vue';

export default {
    name: 'DiesAcademicusPage',
    components: {
        NavBar,
        PageTitle,
        DiesAcademicus,
        FooterComp,
    }
}
</script>